let isScrolling = false;
let isPaused = false;

function initLogoSlider() {
    const slider = document.querySelector('.logo-slider-container');
    if (!slider) return;

    // Set smooth scrolling
    slider.style.scrollBehavior = 'smooth';
    
    // Get original logos
    const originalLogos = Array.from(slider.children);
    const logoCount = originalLogos.length;
    
    // Clone all logos and append to end for seamless looping
    originalLogos.forEach(logo => {
        const clone = logo.cloneNode(true);
        slider.appendChild(clone);
    });

    // Set initial position
    slider.scrollLeft = 0;

    function autoScroll() {
        if (isPaused) return;
        
        const itemWidth = originalLogos[0].offsetWidth;
        const totalWidth = itemWidth * logoCount;
        
        // Always scroll forward
        slider.scrollLeft += itemWidth;
        
        // Check if we need to reset
        if (slider.scrollLeft >= totalWidth) {
            // Reset to beginning without animation
            slider.style.scrollBehavior = 'auto';
            slider.scrollLeft = 0;
            // Force a reflow
            slider.offsetHeight;
            slider.style.scrollBehavior = 'smooth';
        }
    }

    // Add hover event listeners to pause scrolling
    slider.addEventListener('mouseenter', () => {
        isPaused = true;
    });
    
    slider.addEventListener('mouseleave', () => {
        isPaused = false;
    });

    // Start continuous scrolling
    setInterval(autoScroll, 2000);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initLogoSlider);
